import { useRouteMatch } from 'react-router';
import { useAgents } from './useAgents';
import {
  Table,
  Button,
  Link,
  PermissionCheck,
  Toggle,
  SearchPanel,
  GoToDetails,
} from '../../components';
import { PERMISSIONS } from '../../shared/constants/permissions';

const AgentsPage = () => {
  const { params } = useRouteMatch<{ organization_id: string }>();
  const {
    agents,
    loading,
    sort,
    setSort,
    search,
    setSearch,
    isActive,
    showActiveAgents,
    setShowActiveAgents,
  } = useAgents();

  return (
    <>
      <div className="flex justify-between items-center mb-sm">
        <div className="flex gap-x-md">
          <SearchPanel
            search={search}
            onSearch={setSearch}
            withPaginate={false}
            searchClassName="text-medium"
          />
          <Toggle
            value={showActiveAgents}
            onChange={() => setShowActiveAgents(prev => !prev)}
            label="Show Active Agents"
          />
        </div>
        <PermissionCheck action={PERMISSIONS.CREATE_AGENTS}>
          <Button
            label="Add New"
            url={`/agents/${params.organization_id}/new`}
            size="medium"
          />
        </PermissionCheck>
      </div>
      <Table
        sort={sort}
        onSort={setSort}
        loading={loading}
        data={agents ?? []}
        verticalAlign="top"
        emptyMessage="No Agents"
        config={{
          columns: [
            {
              header: 'Active',
              sortName: 'active',
              cellClassName: 'max-w-[3rem] min-w-[3rem] w-[3rem]',
              getValue: () => (
                <p className="text-center flex flex-1 items-center justify-center">
                  {isActive ? '✅' : '❌'}
                </p>
              ),
            },
            {
              header: 'Title',
              sortName: 'title',
              cellClassName: 'font-semibold max-w-[16rem] min-w-[14rem]',
              getValue: ({ id, title }) => (
                <Link
                  withIcon
                  withDecoration
                  children={title}
                  url={`/agents/${params.organization_id}/${id}`}
                />
              ),
            },
            {
              header: '',
              align: 'right',
              cellClassName: 'max-w-[8rem] min-w-[8rem] align-middle',
              getValue: ({ id }) => (
                <GoToDetails url={`/agents/${params.organization_id}/${id}`} />
              ),
            },
          ],
        }}
      />
    </>
  );
};

export default AgentsPage;
